import { useDispatch } from 'react-redux';
import { getCachedMediaUrl } from '../../../lib/utils/utils';
import { setActiveImageList, setActiveImageUrl } from '../../../Features/inventoryManagementSlice';

function ProductColorBox({ color, isActive, id }) {
    const dispatch = useDispatch();

    function handleColorClick() {
        const colorVariant = {
            activeImageList: color.imageList,
            color: color.color,
        }
        dispatch(setActiveImageList(colorVariant));
        dispatch(setActiveImageUrl(color.imageList[0]));
    }

    return (
        <div onClick={handleColorClick} className={`cursor-pointer w-[106px] h-fit flex flex-col rounded-2xl bg-[#F5F5F5] ${isActive ? 'border-b-2 border-link' : ''}`}>
            <div className="w-full h-24 rounded-2xl overflow-hidden">
                <img className='size-full object-cover' src={getCachedMediaUrl(color.imageList[0])} alt="" />
            </div>

            <p className='text-center text-[10px] leading-[22px]'>{color.color}</p>
        </div>
    );
}

export default ProductColorBox;
